module.exports = __webpack_public_path__ + "static/img/Suitable-Printer-02.e131c78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/Suitable-Printer-02.png
// module id = xJUd
// module chunks = 150